module.exports = __webpack_public_path__ + "img/horizontal_3_6_7005.ae4c7ffa.png";